export const URL = 'https://disease.sh/v3/covid-19';

export const tails = {
  ALL: '/all',
  COUNTRIES: '/countries',
  LAST_120_DAYS: '/historical/all?lastdays=120',
};